export default __webpack_public_path__ + "static/media/meinpink.331b094a.jpg";